import i18n, { InitOptions } from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import { initReactI18next } from 'react-i18next';

import enFallbackTranslations from '../assets/translations/en.json';
import { Language } from '../enum';

const expirationTime = 30 * 60 * 1000; // 30 min
const endpoint = 'https://oe-thirdparty-service-ext.openenglish.com/v1';
const projectId = '389108';

const initConfig: InitOptions = {
  load: 'languageOnly',
  debug: process.env.NODE_ENV !== 'production',
  fallbackLng: Language.en,
  lng: Language.en,
  cache: {
    enabled: true,
  },
  react: {
    useSuspense: true,
  },
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
};

const replaceUnicodeEscapes = (str: string) => {
  // First, decode escaped Unicode sequences (e.g., \\u2019 => ’)
  str = str.replace(/\\\\u([0-9A-Fa-f]{4})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)));

  // Then, handle actual Unicode sequences (e.g., \u2019 => ’)
  str = str.replace(/\\u([0-9A-Fa-f]{4})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)));
  return str;
}

const replaceUnicodeEscapesInObject = (obj: any) => {
  Object.keys(obj).forEach((key: string) => {
    if (typeof obj[key] === 'string') {
      obj[key] = replaceUnicodeEscapes(obj[key]);
    } else if (typeof obj[key] === 'object') {
      replaceUnicodeEscapesInObject(obj[key]);
    }
  });
}

i18n
  .use(initReactI18next)
  .use(ChainedBackend)
  .init({
    ...initConfig,
    backend: {
      backends: [LocalStorageBackend, HttpApi],
      backendOptions: [
        { expirationTime, defaultVersion: 'v1' },
        { loadPath: endpoint + '/translations/{{lng}}', queryStringParams: { projectId } },
      ],
    },
  })
  .then(() => {
    // Add English translations as a fallback
    i18n.addResourceBundle('en', 'translation', enFallbackTranslations, true, false);

    // Fetch translations from the backend and overwrite English translations
    i18n.loadLanguages(['en']);
  });
  i18n.on('loaded', () => {
    replaceUnicodeEscapesInObject(i18n.store.data)
  });

export { i18n };

window.switchLanguage = (lang: string) => i18n.changeLanguage(lang);
